import type { IModule } from "../security/models/module-model";

export default <IModule>{
  routes: [
    {
      path: "/module/pools",
      name: "pools",
      meta: { requiresAuth: true, title: "routes.pools" },
      component: () => import("./main.vue")
    }
  ]
};
